import status from "../../constants/actionStatus";

const getLiveVideoDetailReducer = (
    state = {
        liveVideoDetail: {},
    },
    action = {}
) => {
    switch (action.type) {
    case "LIVE_VIDEO_REQUEST":
        return {
            status: status.PENDING,
            liveVideoDetail: {},
        };
    case "LIVE_VIDEO_SUCCESS":
        return {
            status: status.SUCCESS,
            liveVideoDetail: action.payload,
        };

    case "LIVE_VIDEO_FAILURE":
        return {
            status: status.ERROR,
            liveVideoDetail: {},
        };
    default:
        return state;
    }
};

export default getLiveVideoDetailReducer;
